'use strict';

const MODAL_INNER_SELECTOR = 'favorites-modal-inner';
const MODAL_WRAPPER_SELECTOR = '.favorites-modal--login';
const HEADER_BUTTON_SELECTOR = 'global-header-favorites-button';

export function init() {
    const modalInner = document.getElementById(MODAL_INNER_SELECTOR);
    const modalWrapper = document.querySelector(MODAL_WRAPPER_SELECTOR);
    const headerButton = document.getElementById(HEADER_BUTTON_SELECTOR);

    if (modalInner === null) {
        return false;
    }

    window.addEventListener('scroll', function () {
        let scrollDebounce;
        clearTimeout(scrollDebounce);

        scrollDebounce = setTimeout(function () {
            if (!modalWrapper) {
                return;
            }
            
            if (window.pageYOffset === 0 && modalWrapper.classList.contains("active")) {
                headerButton.classList.add("global-header__button--favorites-top")
                modalInner.classList.add("favorites-modal__inner--fixed");
            } else {
                headerButton.classList.remove("global-header__button--favorites-top")
                modalInner.classList.remove("favorites-modal__inner--fixed");
            }
        }, 100);
    });
}

export default { init }
